/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { camelCase, cloneDeep, uniqueId } from 'lodash';

function handleInitialAdjustments({
  questionnaire,
  setFieldValue,
  productsData,
  productPlansData,
  planCoveragePersonData,
  globalQuestionnaire,
  setShowProductPlansSection,
  personData
}) {
  try {

    const personPartyTypeAnswerOption = globalQuestionnaire.find((question) => question.idQuestion === 1891)?.idAnswerOption;

    if (personPartyTypeAnswerOption === 7555 || personPartyTypeAnswerOption === 7556) {
      setShowProductPlansSection(true);
    }

    questionnaire = questionnaire.map((group) => {
      return group.map((groupQuestion) => {
        if (groupQuestion.idQuestion === 1963) {
          groupQuestion.visibleQuestion = false;
        }

        if (groupQuestion.idQuestion === 1958) {
          groupQuestion.visibleQuestion = personPartyTypeAnswerOption === 7556;
        }

        if (groupQuestion.idQuestion === 1959) {
          groupQuestion.visibleQuestion = personPartyTypeAnswerOption === 7556;
        }

        if (groupQuestion.idQuestion === 1960) {
          groupQuestion.visibleQuestion = personPartyTypeAnswerOption === 7555;
        }

        return groupQuestion;
      });
    });

    return handleGroup({
      questionnaire,
      setFieldValue,
      productsData,
      productPlansData,
      planCoveragePersonData,
      personData
    });

  } catch (e) {
    console.log("PRODUCT_PLAN - handleInitialAdjustments error", e)
  }
}

function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue,
}) {
  try {
    let saveFilteredQuestionnaire = false;

    if (saveFilteredQuestionnaire) setQuestionnaire(questionnaireUpdated);
  } catch (e) {
    console.log("PRODUCT_PLAN - handleQuestionChange error", e)
  }
}

async function handleRequestSerproCnpj({
  question: rootQuestion,
  data,
  questionnaire,
  setQuestionnaire,
  setFieldValue,
}) {
  try {
  } catch (e) {
    console.log('PRODUCT_PLAN - handleRequestSerproCnpj error', e)
  }
};

function handleGroup({
  questionnaire,
  setFieldValue,
  productsData,
  productPlansData,
  planCoveragePersonData,
  personData
}) {
  try {
    const groups = [];
    const baseGroup = cloneDeep(questionnaire[0]);
    productPlansData.map((productPlan) => {
      const planProductName = productsData.find((product) => product.value === productPlan.idProduct)?.label;

      const newGroup = baseGroup.map((qst) => {
        qst = cloneDeep(qst);
        qst.key = `${camelCase(qst.dsQuestion)}_${qst.idQuestion}${uniqueId()}_${uniqueId()}`;
        qst.idQuestionnaireAnswers = null;
        qst.idQuestionnaireAnswersParent = null;
        qst.idQuestionnaireAnswersRoot = null;
        qst.answer = null;
        qst.idAnswerOption = null;

        if (qst.idQuestion === 1963) {
          qst.visibleQuestion = false;
          qst.answer = planProductName;
        }

        if (qst.idQuestion === 1957) {
          qst.visibleQuestion = false;
          qst.answer = productPlan.idProductPlan;
          qst.productPlanName = productPlan.productPlanName
          qst.idProductPlan = productPlan.idProductPlan;
        }

        if (planCoveragePersonData) {
          const planCoveragePerson = planCoveragePersonData.find((planCoveragePerson) => planCoveragePerson.idProductPlan === productPlan.idProductPlan);

          if (qst.idQuestion === 1958 && planCoveragePerson) {
            qst.answer = planCoveragePerson?.minPersonCommissionRate || '';
            qst.answerJson = planCoveragePerson?.minPersonCommissionRate || '';
            setFieldValue && setFieldValue(qst.key, planCoveragePerson?.minPersonCommissionRate || '');
          }

          if (qst.idQuestion === 1959 && planCoveragePerson) {
            qst.answer = planCoveragePerson?.maxPersonCommissionRate || '';
            qst.answerJson = planCoveragePerson?.maxPersonCommissionRate || '';
            setFieldValue && setFieldValue(qst.key, planCoveragePerson?.maxPersonCommissionRate || '');
          }
        };


        if(qst.idQuestion === 1960 && personData && personData.personRelationshipsTail[290]) {
          personData.personRelationshipsTail[290][0].relationshipContent.productPlans.map(({idProductPlan, remuneration}) => {
            if (idProductPlan === productPlan.idProductPlan) qst.answer = remuneration;
          });
        }

        if (qst.key) setFieldValue(qst.key, String(qst.answer));
        return qst;
      })

      groups.push(newGroup)
    })
    return groups;
  } catch (e) {
    console.log('PRODUCT_PLAN - handleGroup error', e)
  }
}

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
  handleRequestSerproCnpj,
}

export { events };